import { render, staticRenderFns } from "./PaymentRequisitionAttachmentListItem.vue?vue&type=template&id=e64895a2&"
import script from "./PaymentRequisitionAttachmentListItem.vue?vue&type=script&lang=ts&"
export * from "./PaymentRequisitionAttachmentListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports